import pendingChildTestsActions from '../actions/PendingAssessmentsActions';

function populatePendingChildTest(action, state) {
    return Object.assign({}, state[action.identifier], { settings: action.body.settings });
}

function populatePendingChildTestWithError(action, state) {
    return Object.assign({}, state[action.identifier], { settings: action.body.error });
}

function removePendingAssessment(identifier, state) {
    delete state[identifier];
    return state;
}

export default function (state = {}, action) {
    switch (action.type) {
    case pendingChildTestsActions.types.CHILD_ASSESSMENT_ITEM_LOAD_SUCCESS:
        return Object.assign({}, state, {
            [action.identifier]: {
                assessmentItem: action.body.assessmentItem,
            },
        });
    case pendingChildTestsActions.types.CHILD_ASSESSMENT_ITEM_LOAD_FAILED:
        return Object.assign({}, state, {
            [action.identifier]: {
                assessmentItem: action.body.error,
            },
        });
    case pendingChildTestsActions.types.CHILD_TEST_SETTINGS_LOAD_SUCCESS:
        return Object.assign({}, state, {
            [action.identifier]: populatePendingChildTest(action, state),
        });
    case pendingChildTestsActions.types.CHILD_TEST_SETTINGS_LOAD_FAILED:
        return Object.assign({}, state, {
            [action.identifier]: populatePendingChildTestWithError(action, state),
        });
    case pendingChildTestsActions.types.REMOVE_PENDING_ASSESSMENT:
        return removePendingAssessment(action.identifier, state);
    default:
        return state;
    }
}
